import units from "../routes/children";

export default [
  {
    name: "test-drives",
    meta: {
      title: "Test Drives",
      sort: 7,
      authenticatable: true,
      description: "Test Drives",
      icon: "mdi-speedometer",
      permission: false,
      roles: ["admin", "dealer"],
    },
    children: [].concat(units),
  },
];
